var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCallerLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.2583 14.5393L16.3284 14.2048C15.6248 14.1241 14.9327 14.3663 14.4367 14.8623L12.3143 16.9847C9.04988 15.3237 6.37379 12.6591 4.71277 9.38323L6.84672 7.24927C7.34272 6.75327 7.58495 6.06118 7.50421 5.35755L7.1697 2.45076C7.03128 1.28574 6.05081 0.409088 4.87425 0.409088H2.87872C1.57528 0.409088 0.490998 1.49337 0.571742 2.79681C1.18309 12.6476 9.06142 20.5144 18.9007 21.1257C20.2041 21.2065 21.2884 20.1222 21.2884 18.8188V16.8232C21.2999 15.6582 20.4233 14.6777 19.2583 14.5393Z",
    fill: "#0081FE",
    fillOpacity: 0.7
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallerLogo);
export default __webpack_public_path__ + "static/media/CallerLogo.bce13feba3c394aec4c3b1df7bf936a7.svg";
export { ForwardRef as ReactComponent };